var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-selected-container", attrs: { "data-app": "" } },
    [
      _c(
        "div",
        { staticClass: "edit-selected-form scroll-fire-fox" },
        _vm._l(_vm.fields, function(field) {
          return _c(
            "div",
            { key: field.id, staticClass: "edit-selected-field-container" },
            [
              _c(
                "label",
                {
                  class: { required: field.required },
                  attrs: { for: field.label }
                },
                [_vm._v("\n        " + _vm._s(field.label) + "\n      ")]
              ),
              _vm._v(" "),
              field.disable
                ? _c("div", { staticClass: "edit-selected-field" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("fillField")(_vm.currentValues[field.var_name])
                        ) +
                        "\n      "
                    )
                  ])
                : _vm.hasMultipleValues(field) &&
                  field.input_type !== "checkbox"
                ? _c(
                    "div",
                    {
                      staticClass: "edit-selected-field editable",
                      on: {
                        click: function($event) {
                          return _vm.makeMultipleValuesFieldEditable(field)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("MultipleValuesFound"))
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("ClickToEdit")))])
                    ]
                  )
                : _vm.isStandardInput(field.input_type)
                ? _c("input", {
                    class: {
                      "required-not-filled": _vm.requiredWasMadeEmpty(field)
                    },
                    attrs: {
                      type: _vm.getSpecificStandardInputType(field.input_type),
                      id: field.label
                    },
                    domProps: { value: _vm.getValue(_vm.currentValues, field) },
                    on: {
                      change: function($event) {
                        return _vm.updateValue(field, $event.target.value)
                      }
                    }
                  })
                : _vm.isSelectInput(field.input_type)
                ? _c("treeselect", {
                    staticClass: "treeselect",
                    class: {
                      "required-not-filled": _vm.requiredWasMadeEmpty(field)
                    },
                    attrs: {
                      value: _vm.getValue(_vm.currentValues, field),
                      options: _vm.getSpecificListOfOptions(field),
                      clearable: _vm.selectIsClearable(field),
                      disabled: field.multi_select_disable,
                      disableFuzzyMatching: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateValue(field, $event)
                      }
                    }
                  })
                : field.input_type === "user"
                ? _c("treeselect", {
                    staticClass: "treeselect",
                    class: {
                      "required-not-filled": _vm.requiredWasMadeEmpty(field)
                    },
                    attrs: {
                      value: _vm.getValue(_vm.currentValues, field),
                      options: _vm.optionsUser,
                      normalizer: _vm.userNormalizer,
                      clearable: _vm.selectIsClearable(field),
                      disabled: field.multi_select_disable,
                      disableFuzzyMatching: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateValue(field, $event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              field.input_type === "checkbox"
                ? _c(
                    "div",
                    [
                      _c("v-checkbox", {
                        attrs: {
                          "input-value": _vm.getValue(_vm.currentValues, field),
                          ripple: false,
                          disabled: field.disable,
                          indeterminate: _vm.hasMultipleValues(field),
                          "false-value": 0,
                          "true-value": 1,
                          "hide-details": true,
                          disableFuzzyMatching: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateValue(field, $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "revert-button",
                  on: {
                    click: function($event) {
                      return _vm.resetFieldValue(field)
                    }
                  }
                },
                [
                  _c("RevertIcon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCancelEdit(field),
                        expression: "showCancelEdit(field)"
                      }
                    ],
                    staticClass: "revert-icon"
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "saveDiv-buttons-container" }, [
        _c("input", {
          staticClass: "form-input form-next form-previous",
          attrs: { type: "submit" },
          domProps: { value: _vm.$t("Cancel") },
          on: {
            click: function($event) {
              return _vm.closeEditSelected("local")
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-input form-next",
          attrs: { type: "submit" },
          domProps: { value: _vm.$t("ApplyChanges") },
          on: {
            click: function($event) {
              return _vm.leaveEditSelect("apply")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.leaveEditSelectedDialog,
          title: _vm.$t("LeaveEditSelected"),
          content:
            _vm.$t("UnsavedChanges") +
            "\n" +
            _vm.$t("CheckLeaveEditSelected") +
            "\n" +
            _vm.$t("ChangesWillBeLost"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.leaveEditSelectedDialog = false
          },
          secondaryAction: function($event) {
            return _vm.$emit("close")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cb9d5e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb9d5e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/MultiSelectionForm/MultiSelectionEditSelected.vue
// module id = null
// module chunks = 